import React from "react";
import { Dropdown } from "react-bootstrap";

const CustomToggle = React.forwardRef(({ onClick, hasNotes }, ref) => (
    <button
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        className="actions-toggle-btn dropdown-toggle-custom position-relative"
    >
        <i className="far fa-ellipsis-v"></i>
        {hasNotes && (
            <span 
                className="position-absolute bg-danger rounded-circle animate-pulse" 
                style={{ width: '8px', height: '8px', top: '3px', right: '3px', border: '1px solid white' }}
                title="يوجد ملاحظات على هذا المستخدم"
            ></span>
        )}
    </button>
));

const UserActionsDropdown = ({ item, t, onAction }) => {
    if (!item) return null;

    const userTypeId = item.UserType ? item.UserType.Id : null;

    return (
        <Dropdown alignRight>
            <Dropdown.Toggle as={CustomToggle} hasNotes={item.notesCount > 0} />

            <Dropdown.Menu className="shadow border-0 py-2" style={{ borderRadius: '10px', zIndex: 1050, minWidth: '180px' }}>
                {item.IsDeleted ? (
                    <>
                        <Dropdown.Item onClick={() => onAction("restore", item)} className="py-2">
                            <i className="far fa-trash-undo-alt ml-2 text-success"></i>
                            {t("Pages.UsersControl.action.undo")}
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => onAction("fire", item)} className="text-danger py-2">
                            <i className="far fa-fire-alt ml-2"></i>
                            {t("Pages.UsersControl.action.fire")}
                        </Dropdown.Item>
                    </>
                ) : (
                    <>
                        <Dropdown.Item onClick={() => onAction("moreInfo", item)} className="py-2">
                            <i className="text-dark far fa-info ml-2"></i>
                            {t("Pages.UsersControl.action.info")}
                        </Dropdown.Item>

                        {userTypeId !== 7 && (
                            <Dropdown.Item onClick={() => onAction("edit", item)} className="py-2">
                                <i className="text-info far fa-edit ml-2"></i>
                                {t("Pages.UsersControl.action.edit")}
                            </Dropdown.Item>
                        )}

                        <Dropdown.Item onClick={() => onAction("notes", item)} className="py-2 d-flex align-items-center justify-content-between">
                            <span className="d-flex align-items-center">
                                <i className={`far fa-sticky-note ml-2 ${item.notesCount > 0 ? "text-danger" : "text-primary"}`}></i>
                                {t("Pages.UsersControl.action.notes")}
                            </span>
                            {item.notesCount > 0 && (
                                <span className="badge badge-danger p-1 px-2" style={{ borderRadius: '10px', fontSize: '0.7rem' }}>
                                    {item.notesCount}
                                </span>
                            )}
                        </Dropdown.Item>

                        {userTypeId !== 7 && (
                            <Dropdown.Item onClick={() => onAction("useAs", item)} className="py-2">
                                <i className="text-warning fad fa-alien ml-2"></i>
                                {t("Pages.UsersControl.action.useAs") + " " + item.Name.split(" ")[0]}
                            </Dropdown.Item>
                        )}

                        {userTypeId !== 7 && (
                            <Dropdown.Item onClick={() => onAction("change_password", item)} className="py-2">
                                <i className="text-secondary far fa-key ml-2"></i>
                                {t("Pages.UsersControl.action.change_password")}
                            </Dropdown.Item>
                        )}

                        {userTypeId !== 1 && userTypeId !== 7 && (
                            <Dropdown.Item onClick={() => onAction("changeLoginInfo", item)} className="py-2">
                                <i className="text-success far fa-fingerprint ml-2"></i>
                                {t("Pages.UsersControl.action.changeLoginInfo")}
                            </Dropdown.Item>
                        )}

                        {userTypeId === 5 && (
                            <Dropdown.Item onClick={() => onAction("move", item)} className="py-2">
                                <i className="text-warning far fa-exchange ml-2"></i>
                                {t("Pages.StudentInClassRoomsControl.action.move")}
                            </Dropdown.Item>
                        )}

                        {(userTypeId === 2 || userTypeId === 7) && (
                            <Dropdown.Item onClick={() => onAction("bills", item)} className="py-2">
                                <i className="text-info far fa-file-invoice-dollar ml-2"></i>
                                {t("Pages.UsersControl.action.bills")}
                            </Dropdown.Item>
                        )}

                        <Dropdown.Divider className="my-1" />

                        {/* Logs and Historical Reports */}
                        <Dropdown.Item onClick={() => onAction("lessonMarks", item)} className="py-2">
                            <i className="text-warning far fa-graduation-cap ml-2"></i>
                            {t("Pages.UsersControl.action.lessonMarks") || "علامات الدروس والمهام"}
                        </Dropdown.Item>

                        <Dropdown.Item onClick={() => onAction("lessonViews", item)} className="py-2">
                            <i className="text-primary far fa-book-open ml-2"></i>
                            {t("Pages.UsersControl.action.lessonViews") || "سجل مشاهدة الدروس"}
                        </Dropdown.Item>

                        <Dropdown.Item onClick={() => onAction("downloadFiles", item)} className="py-2">
                            <i className="text-success far fa-download ml-2"></i>
                            {t("Pages.UsersControl.action.downloadFiles") || "الملفات المحملة"}
                        </Dropdown.Item>

                        <Dropdown.Item onClick={() => onAction("errorReports", item)} className="py-2">
                            <i className="text-danger far fa-bug ml-2"></i>
                            {t("Pages.UsersControl.action.errorReports") || "بلاغات الأخطاء"}
                        </Dropdown.Item>

                        <Dropdown.Item onClick={() => onAction("contactMessages", item)} className="py-2">
                            <i className="text-info far fa-envelope ml-2"></i>
                            {t("Pages.UsersControl.action.contactMessages") || "رسائل اتصل بنا"}
                        </Dropdown.Item>

                        <Dropdown.Divider className="my-1" />

                        {/* Administrative / Permissions / School changes */}
                        {userTypeId === 2 && (
                            <Dropdown.Item onClick={() => onAction("testUser", item)} className="py-2">
                                <i className="text-danger fad fa-alarm-exclamation ml-2"></i>
                                {t("Pages.UsersControl.action.testUser")}
                            </Dropdown.Item>
                        )}

                        {userTypeId === 3 && (
                            <Dropdown.Item onClick={() => onAction("changePermission", item)} className="py-2">
                                <i className="text-danger fad fa-water-lower ml-2"></i>
                                {t("Pages.UsersControl.action.makeSchoolTeacher")}
                            </Dropdown.Item>
                        )}

                        {(userTypeId === 3 || userTypeId === 4) && (
                            <Dropdown.Item onClick={() => onAction("accessToAllClass", item)} className="py-2">
                                <i className="text-primary fa-solid fa-users-between-lines ml-2"></i>
                                {t("Pages.UsersControl.action.accessToAllClass")}
                            </Dropdown.Item>
                        )}

                        {userTypeId === 4 && (
                            <>
                                <Dropdown.Item onClick={() => onAction("changePermission", item)} className="py-2">
                                    <i className="text-danger fad fa-water-rise ml-2"></i>
                                    {t("Pages.UsersControl.action.makeSchoolManager")}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => onAction("showChangeSchool", item)} className="py-2">
                                    <i className="text-primary far fa-school ml-2"></i>
                                    {t("Pages.UsersControl.action.changeSchool")}
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => onAction("changeUserType", item)} className="py-2">
                                    <i className="text-warning far fa-user-tag ml-2"></i>
                                    {t("Pages.UsersControl.action.changeTypeToUser")}
                                </Dropdown.Item>
                            </>
                        )}

                        {userTypeId === 2 && (
                            <Dropdown.Item onClick={() => onAction("changeUserType", item)} className="py-2">
                                <i className="text-warning far fa-chalkboard-teacher ml-2"></i>
                                {t("Pages.UsersControl.action.changeTypeToSchoolTeacher")}
                            </Dropdown.Item>
                        )}

                        <Dropdown.Divider className="my-1" />

                        {userTypeId !== 7 && (
                            <Dropdown.Item className="text-danger py-2" onClick={() => onAction("remove", item)}>
                                <i className="far fa-trash ml-2"></i>
                                {t("Pages.UsersControl.action.remove")}
                            </Dropdown.Item>
                        )}
                    </>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default UserActionsDropdown;
